import {
  AHIcon,
  AHText,
  Box,
  ListItem,
  TouchableBox,
  useLayoutContext,
} from "arkh";
import React from "react";
import { graphql, useFragment, useMutation } from "react-relay";
import { useIntlTokens } from "../../../../../components/mobile/useIntlTokens";
import { LinkedWorkspaceProductItem } from "../../../../../components/LinkedContent/LinkedWorkspaceProductItem";
import { WorkspaceSignalEditMainProductsUnLinkMutation } from "./__generated__/WorkspaceSignalEditMainProductsUnLinkMutation.graphql";
import { WorkspaceSignalEditMainProducts_Signal$key } from "./__generated__/WorkspaceSignalEditMainProducts_Signal.graphql";

export function WorkspaceSignalEditMainProducts(props: {
  signal: WorkspaceSignalEditMainProducts_Signal$key;
  openLinkProduct?(params: {
    linkedProductIds: string[];
    signalWorkspaceId: string;
  }): void;
  openProduct(id: string): void;
  disabled?: boolean;
}) {
  const intl_tokens = useIntlTokens();
  const layout = useLayoutContext();
  const signal = useFragment(
    graphql`
      fragment WorkspaceSignalEditMainProducts_Signal on SignalWorkspace {
        id
        linkedProducts {
          id
          ...LinkedWorkspaceProductItem_WorkspaceProduct
        }
      }
    `,
    props.signal
  );

  const [unLinkProduct] =
    useMutation<WorkspaceSignalEditMainProductsUnLinkMutation>(graphql`
      mutation WorkspaceSignalEditMainProductsUnLinkMutation(
        $productId: ID!
        $signalWorkspaceId: ID!
      ) {
        signalWorkspace(id: $signalWorkspaceId) {
          unlinkProduct(productId: $productId) {
            id
            linkedProducts {
              id
            }
          }
        }
      }
    `);

  return (
    <>
      <ListItem
        isFirst
        color={props.disabled ? "transparent" : "surface-primary"}
        border="border-primary"
        isLast={signal.linkedProducts.length === 0}
        disabled
        left={<AHIcon type="product" color="text-secondary" />}
        right={
          props.disabled ? null : (
            <TouchableBox
              borderColor="border-primary"
              cornerRadius="medium"
              spaceHorizontal="small"
              disabled={props.disabled}
              style={{
                height: layout.circle.smallMedium,
                borderWidth: 1,
                alignItems: "center",
                justifyContent: "center",
              }}
              onPress={() => {
                props.openLinkProduct?.({
                  linkedProductIds: signal.linkedProducts.map((v) => v.id),
                  signalWorkspaceId: signal.id,
                });
              }}
            >
              <AHText>{intl_tokens.AddProduct}</AHText>
            </TouchableBox>
          )
        }
      >
        <ListItem.TitleSecondary>
          {intl_tokens.Products}
        </ListItem.TitleSecondary>
      </ListItem>
      {signal.linkedProducts.length > 0 ? (
        <Box
          color={props.disabled ? "transparent" : "surface-primary"}
          borderColor="border-primary"
          style={{
            borderWidth: 1,
            borderTopWidth: 0,
          }}
          cornerRadiusBottomLeft="large"
          cornerRadiusBottomRight="large"
        >
          <Box
            style={{
              paddingRight: layout.space.medium,
              paddingBottom: layout.space.medium,
              flexDirection: "row",
              justifyContent: "flex-end",
              flexWrap: "wrap",
            }}
          >
            {signal.linkedProducts.map((product) => (
              <Box key={product.id} spaceTop="medium" spaceLeft="medium">
                <LinkedWorkspaceProductItem
                  product={product}
                  onPressProduct={(id) => {
                    props.openProduct(id);
                  }}
                  unLinkProduct={
                    props.disabled
                      ? undefined
                      : (id) => {
                          unLinkProduct({
                            variables: {
                              signalWorkspaceId: signal.id,
                              productId: id,
                            },
                          });
                        }
                  }
                />
              </Box>
            ))}
          </Box>
        </Box>
      ) : null}
    </>
  );
}
